import { useEffect, useState } from 'react';
import {
  ADDITIONAL_CONTEXT_MAX_LENGTH,
  validateAdditionalContext
} from '../utils/easyModeValidation';
import useCaseFieldUpdate from './useCaseFieldUpdate';

const ADDITIONAL_CONTEXT_FIELD_PATH = 'caseInfo.additionalContext';

const useEasyModeContextStep = ({ caseData }) => {
  const { updateCase } = useCaseFieldUpdate();
  const [additionalContext, setAdditionalContext] = useState('');

  useEffect(() => {
    if (caseData) {
      setAdditionalContext(caseData.caseInfo?.additionalContext ?? '');
    }
  }, [caseData]);

  const { error } = validateAdditionalContext({ additionalContext });

  const handleChange = (event) => setAdditionalContext(event.target.value);

  // the case field is the durable copy the agent reads on a rerun; the submit payload is only the
  // immediate one, so this has to land before the POST does. Clamped rather than refused: the textarea
  // caps typing, but a paste through a stale value or an imported case can still arrive over the limit,
  // and the cap exists to protect the prompt budget rather than to reject the user's note.
  const save = () =>
    updateCase({
      data: {
        [ADDITIONAL_CONTEXT_FIELD_PATH]: additionalContext.trim().slice(0, ADDITIONAL_CONTEXT_MAX_LENGTH)
      }
    });

  return {
    additionalContext,
    error,
    maxLength: ADDITIONAL_CONTEXT_MAX_LENGTH,
    handleChange,
    handleBlur: save,
    save
  };
};

export default useEasyModeContextStep;
